module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.b907762.eot";